import {ApiClientCommunication} from 'neo-common';

export class PlayerConfigurationResponse extends ApiClientCommunication.ResponseBase {

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/PlayerConfigurationResponse.ts
 **/